import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { DisableMultipleModulesComponent } from './disable-multiple-modules/disable-multiple-modules.component';
import { PricingGroupComponent } from './pricing-group/pricing-group.component';
import { BankGroupComponent } from './bank-group/bank-group.component';

@Component({
  selector: 'app-settings',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, AccordionModule, ButtonModule, DisableMultipleModulesComponent, PricingGroupComponent, BankGroupComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class UserSettingsPage {
  public drawerCreatePricingGroupStatus: boolean = false;
  public drawerCreateBankGroupStatus: boolean = false;

  public openDrawerCreatePricingGroupStatus = (event: Event) => {
    event.stopPropagation();
    this.drawerCreatePricingGroupStatus = true;
  };

  public openDrawerCreateBankGroupStatus = (event: Event) => {
    event.stopPropagation();
    this.drawerCreateBankGroupStatus = true;
  };
}
